module.exports = __webpack_public_path__ + "img/40_38_040_460.83699600.jpg";